import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { FormDialog } from 'components';
import { TaskProgressModalContent } from 'pages/Funds/components/ProcessManagement/TaskProgressModalContent';
import { useGetTaskProgressDetails } from 'services/hooks/firms';
import { getNumberValue } from 'utilities';
import type { TaskProgressDialogProps } from './types';

const TaskProgressDialog: FC<TaskProgressDialogProps> = ({
  open,
  onClose,
  cellKey,
  companyName,
  fundName,
  firmName,
  task,
  measurementDateName,
  companySlug,
  isDocuments,
}) => {
  const { summary: taskDescription } = task || {};
  const { data: taskProgressDetails, isLoading, refetch } = useGetTaskProgressDetails({
    task,
    shouldQueryAutomatically: open,
  });
  const percentageOfProgress = (getNumberValue(task?.progress?.completed) / (task?.progress?.total ?? 1)) * 100;

  return (
    <FormDialog
      open={open}
      onClose={onClose}
      title={companyName}
      subtitle={`${fundName} / ${firmName}`}
      showCancelButton={false}
      showSaveButton={false}
      disableTitleClose={false}
      isLoading={isLoading}
      loadingText={isLoading ? 'Loading task details...' : undefined}
      classesContent={{ content: { marginBottom: 0 } }}
      cellKey={cellKey}
      disableWhenLedgerOpen>
      {taskProgressDetails ? (
        <TaskProgressModalContent
          measurementDateName={measurementDateName}
          percentageOfProgress={percentageOfProgress}
          taskDescription={taskDescription}
          taskProgressDetails={taskProgressDetails}
          companySlug={companySlug}
          isDocuments={isDocuments}
          onDelegationSuccess={refetch}
        />
      ) : (
        <Box p={2}>
          <Typography variant="body2">Task details are unavailable.</Typography>
        </Box>
      )}
    </FormDialog>
  );
};

export default TaskProgressDialog;
